import { Record } from 'immutable'

export const ProTrackLevelRecord = Record({
  id: null,
  welcomeText: null,
  finishText: null,
  goals: null,
  image: null,
  color: null,
  preSurveyLink: null,
  postSurveyLink: null,
  activitiesTotal: null,
  welcomeEmailImage: null,
  finishEmailImage: null,
  active: false,
  order: null,
  deleting: false,
  ratesCount: null,
  isLibrary: false,
})

export default class ProTrackLevel extends ProTrackLevelRecord {}
